<!--==============================
=            treeview            =
===============================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Treviews</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <treeviews1></treeviews1>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Dense mode
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <dense-treeviews></dense-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Checkbox color
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <checkbox-treeviews></checkbox-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Color
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <color-treeviews></color-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Treviews  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Shaped
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <shaped-treeviews></shaped-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Treviews  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Rounded
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <rounded-treeviews></rounded-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Selection type
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <selection-treeviews></selection-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Selectable
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <selectable-treeviews></selectable-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Activatable
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <activatable-treeviews></activatable-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Treviews  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Hoverable
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <hoverable-treeviews></hoverable-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Treviews  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Open-all
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <openall-treeviews></openall-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Slots
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <slots-treeviews></slots-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Searching a directory
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <searching-treeviews></searching-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Async
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <async-treeviews></async-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Treviews  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Custom selectable icons
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <custom-treeviews></custom-treeviews>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import ActivatableTreeviews from "../../components/Apps/Treeviews/ActivatableTreeviews.vue";
import AsyncTreeviews from "../../components/Apps/Treeviews/AsyncTreeviews.vue";
import CheckboxTreeviews from "../../components/Apps/Treeviews/CheckboxTreeviews.vue";
import ColorTreeviews from "../../components/Apps/Treeviews/ColorTreeviews.vue";
import CustomTreeviews from "../../components/Apps/Treeviews/CustomTreeviews.vue";
import DenseTreeviews from "../../components/Apps/Treeviews/DenseTreeviews.vue";
import HoverableTreeviews from "../../components/Apps/Treeviews/HoverableTreeviews.vue";
import OpenallTreeviews from "../../components/Apps/Treeviews/OpenallTreeviews.vue";
import RoundedTreeviews from "../../components/Apps/Treeviews/RoundedTreeviews.vue";
import SearchingTreeviews from "../../components/Apps/Treeviews/SearchingTreeviews.vue";
import SelectableTreeviews from "../../components/Apps/Treeviews/SelectableTreeviews.vue";
import SelectionTreeviews from "../../components/Apps/Treeviews/SelectionTreeviews.vue";
import Treeviews1 from "../../components/Apps/Treeviews/Treeviews1.vue";
import ShapedTreeviews from "../../components/Apps/Treeviews/ShapedTreeviews.vue";
import SlotsTreeviews from "../../components/Apps/Treeviews/SlotsTreeviews.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    ActivatableTreeviews,
    AsyncTreeviews,
    CheckboxTreeviews,
    ColorTreeviews,
    CustomTreeviews,
    DenseTreeviews,
    HoverableTreeviews,
    OpenallTreeviews,
    RoundedTreeviews,
    SearchingTreeviews,
    SelectableTreeviews,
    SelectionTreeviews,
    ShapedTreeviews,
    SlotsTreeviews,
    Treeviews1
  }
};
</script>
<style>
.textt {
  overflow: hidden;
  font-size: 12px;
  overflow: hidden !important;
  max-width: auto;
  max-height: 28px;
  text-overflow: ellipsis;
  line-height: 14px !important;
  white-space: inherit;
  vertical-align: top;

  word-wrap: break-word;
  align-items: center;
}

.card_tittle {
  line-height: 1 !important;
}
</style>

<!--====  End of treeview  ====-->
